"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionModeTemplate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const infobox_1 = require("@completeanatomy/infobox");
const MainPageLayout_1 = __importDefault(require("../MainPageLayout"));
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const lodash_noop_1 = __importDefault(require("lodash.noop"));
function RegionModeTemplate({ mode, region, left = (0, jsx_runtime_1.jsx)(infobox_1.InfoBox, { withHeader: false }), onBack = lodash_noop_1.default, showHistory = true, disabledButtons, resetModel = true, }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const bridge = (0, bridge_1.useBridge)();
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onBackInner = () => {
        const searchParams = new URLSearchParams(location.search);
        const type = searchParams.get('type');
        const mask = searchParams.get('mask');
        if (resetModel) {
            bridge === null || bridge === void 0 ? void 0 : bridge.selectModelAndRegion({
                modelType: type !== null ? +type : bridge_schema_1.ModelType.Male,
                bodyRegionMask: mask !== null ? +mask : bridge_schema_1.BodyRegionMask.Default,
                isOpenedFromInfobox: true,
            });
        }
        if (!type && !mask) {
            navigate('/', { replace: true });
            return onBack();
        }
        return navigate(-1);
    };
    /**
     * @todo Refactor src/screens/Main.tsx and move it to template
     */
    return ((0, jsx_runtime_1.jsx)(MainPageLayout_1.default, { header: (0, jsx_runtime_1.jsx)(StyledHeader, { type: ui_1.HeaderType.WithBackButton, backButton: {
                label: (0, i18n_1.Localized)(i18n_1.Strings.header.back),
                onClick: onBackInner,
            }, children: (0, jsx_runtime_1.jsx)(ui_1.ContentTitle, { title: isMobile ? region : mode, subtitle: isMobile ? '' : region }) }), left: left, showHistory: showHistory, disabledButtons: disabledButtons }));
}
exports.RegionModeTemplate = RegionModeTemplate;
const StyledHeader = (0, styled_components_1.default)(ui_1.Header) `
  z-index: 0;
`;
